import React, { Fragment, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setProgressBarCurrentStep } from '@avalara/bat-apps-shared/client/actions/progress-bar';
import { setCurrentOfferPage } from '../../store/offer';
import { stepNames } from '../../lib/side-effects/progress-bar';
import BuyButton from './buy-button';
import OrderSummary from './order-summary';
import { Pages } from '../../../shared/types/offers';
const StandaloneSummary = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(setCurrentOfferPage(Pages.Summary));
        dispatch(setProgressBarCurrentStep(stepNames.reviewAndBuy));
    }, []);
    return (React.createElement(Fragment, null,
        React.createElement(OrderSummary, null),
        React.createElement(BuyButton, null)));
};
export default StandaloneSummary;
